<script setup lang="ts">
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import LandingTitleLayout from '../LandingTitleLayout.vue';
import { breakpoints } from '@glow/shared/lib/breakpoints';
import { LeftArrowIcon, RightArrowIcon } from '@glow/shared/components/icons';
import type { RouteLocationRaw } from 'vue-router';
import { useGetPopularServices } from '@/features/services';
import { useRoutes } from '@glow/shared/lib/routes';

const { getUrl } = useRoutes();
const { staticUrl } = useRuntimeConfig().public;
const { data: services, suspense } = useGetPopularServices();
await suspense();

function getCatalogLink(
  specialization: string,
  service: string
): RouteLocationRaw {
  return getUrl('partnerCatalog', {
    type: 'master',
    specialization,
    service,
    city: 'moscow',
  });
}
</script>

<template>
  <div id="popular" class="container popular">
    <LandingTitleLayout>
      <template #title>
        <span>Популярные</span>
        услуги
      </template>
    </LandingTitleLayout>

    <Swiper
      :modules="[Navigation]"
      :navigation="{
        prevEl: '.slider__prev',
        nextEl: '.slider__next',
      }"
      :breakpoints="{
        [breakpoints['xs']]: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        [breakpoints['md']]: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        [breakpoints['lg']]: {
          slidesPerView: 5,
          spaceBetween: 32,
        },
      }"
      slides-per-view="auto"
      class="slider"
    >
      <SwiperSlide v-for="service in services" :key="service.id" class="slide">
        <NuxtLink
          :to="getCatalogLink(service.specialization.slug, service.slug)"
        >
          <NuxtImg
            format="webp"
            :src="`${staticUrl}/images/services/${service.id}.jpg`"
            :alt="service.name"
          />
        </NuxtLink>
        <span>{{ service.name }}</span>
      </SwiperSlide>

      <div class="slider__prev"><LeftArrowIcon /></div>
      <div class="slider__next"><RightArrowIcon /></div>
    </Swiper>
  </div>
</template>

<style lang="scss">
.popular .slide {
  text-align: center;
}
</style>

<style lang="scss" scoped>
.popular {
  position: relative;
  z-index: 1;
}

.slider {
  height: auto !important;
  padding: 0 30px;

  &__prev,
  &__next {
    position: absolute;
    top: 30% !important;
    z-index: 999 !important;
    padding: 10px !important;
    color: #fff;
    background: var(--app-gradient-primary) !important;
    border: 3px solid #fff;
    border-radius: 50%;
    cursor: pointer;

    svg {
      width: 28px;
      height: 28px;
    }

    @include media-breakpoint-down(md) {
      display: none;
    }
  }

  &__prev {
    left: 0;
  }

  &__next {
    right: 0;
  }
}

.slide {
  span {
    font-size: 17px;
    line-height: 22px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-bottom: 16px;
    border-radius: 16px;
  }
}
</style>
